import SignInForm from 'components/modules/auth/SignInForm';
import AuthCardLayout from 'layouts/AuthCardLayout';

const SignIn = () => {
  document.title = process.env.REACT_APP_NAME + ' | Sign In';
  return (
    <AuthCardLayout className="pb-md-7">
      <SignInForm />
    </AuthCardLayout>
  );
};

export default SignIn;
